import Image from 'next/image'
import { ArrowRight } from 'lucide-react'
import { ButtonWithIcon } from '@Components/button'
import Link from 'next/link'

interface Content {
  title: string
  bannerImage: string
  subTitle?: string
  size?: string
  button?: string
  imageSizes?: {
    width: number
    height: number
  }
}

const Banner = ({
  title,
  subTitle,
  button,
  bannerImage,
  size,
  imageSizes,
}: Content) => {
  const contents: Content = {
    title,
    subTitle,
    button,
    bannerImage,
    size,
  }
  return (
    <div
      className={`relative m-auto w-full max-w-[83.5rem] pt-0 xl:pt-[2.25rem] ${
        size === 'md' ? 'h-[27.25rem]' : 'h-[48rem] xl:h-[50.25rem]'
      }`}
    >
      <div className='absolute w-full shadow-banner'>
        <Image
          src={bannerImage}
          alt='banner-image'
          width={imageSizes?.width ? imageSizes.width : 100} // Adjusted width based on size
          height={imageSizes?.height ? imageSizes.height : 480} // Adjusted height based on size
          priority
          className={`w-full object-cover xl:rounded-[2rem] ${
            size === 'md' ? 'h-[25rem]' : 'h-[48rem]'
          }`}
        />
        <div className='absolute top-0 h-full w-full bg-gradient-to-r from-content-default to-transparent opacity-60 lg:w-[70%] xl:w-[60%] xl:rounded-l-[2rem]' />
      </div>
      <div
        className={`absolute flex w-[16.5rem] flex-col justify-end px-[1.5rem] py-[1.5rem] md:w-[43.75rem] md:px-[2rem] md:py-[2rem] lg:w-[37.75rem] lg:px-[3rem] lg:py-[3rem] ${
          size === 'md' ? 'h-[25rem]' : 'h-[48rem]'
        }`}
      >
        <div className='text-white'>
          <div className='mb-[0.75rem] text-[3.063rem] font-bold'>
            {contents.title}
          </div>
          <div className='text-[1.563rem] '>{contents.subTitle}</div>
        </div>
        {button && (
          <Link href='/why-us'>
            <ButtonWithIcon
              variant='inverse'
              size='lg'
              rightIcon={<ArrowRight className='h-icon-lg w-icon-lg' />}
              className='mt-[2rem] w-[12.625rem]'
            >
              {contents.button}
            </ButtonWithIcon>
          </Link>
        )}
      </div>
    </div>
  )
}

export default Banner
